export const MEMBER = {
  name: "liveCheck",
  path: "/v1/members/withdrawal",
  checkFlag: { is_live_check: true },
};
export const CODE_VERIFICATION = {
  name: "codeVerification",
  path: "/v1/members/verification",
};
export const EMAIL_VERIFICATION = {
  name: "emailVerification",
  path: "/v1/members/verification",
};
export const PAGE = {
  name: "page",
  path: "/v1/billing-periods/withdrawal-form",
};



// WEBPACK FOOTER //
// ./src/components/withdrawal/withdrawalModels.js